document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var header = document.querySelector('[data-site-header]');
  var mobileNavClose = document.querySelector('[data-mobile-nav-close]');
  var mobileNavCloseIcon = document.querySelector('[data-mobile-nav-close-icon]');
  var searchShell = document.querySelector('[data-search-shell]');
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchDropdown = document.querySelector('[data-search-dropdown]');
  var searchInput = document.getElementById('HeaderSearchInput');
  var searchDefault = document.querySelector('[data-search-default]');
  var searchResults = document.querySelector('[data-search-results]');
  var heroSlider = document.querySelector('[data-hero-slider]');
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartDrawerBody = document.querySelector('[data-cart-drawer-body]');
  var cartDrawerFooter = document.querySelector('[data-cart-drawer-footer]');
  var cartCount = document.querySelector('[data-cart-count]');
  var quickAddModal = document.querySelector('[data-quick-add-modal]');
  var quickAddContent = document.querySelector('[data-quick-add-content]');
  var quickAddCache = {};
  var cartRequest;
  var predictiveRequest;
  var cartDrawerUpdateTimer;
  var cartDrawerPendingLine = null;
  var cartDrawerPendingQuantity = null;
  var cartDrawerRequestInFlight = false;
  var lastScrollTop = window.scrollY || 0;
  var headerLockedOpen = false;
  var ticking = false;

  if (toggle && header) {
    toggle.addEventListener('click', function () {
      header.classList.toggle('is-open');
      var expanded = header.classList.contains('is-open');
      header.classList.remove('is-hidden-on-scroll');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      document.body.classList.toggle('mobile-nav-open', expanded);
    });
  }

  if (mobileNavClose && header && toggle) {
    mobileNavClose.addEventListener('click', function () {
      header.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-nav-open');
    });
  }

  if (mobileNavCloseIcon && header && toggle) {
    mobileNavCloseIcon.addEventListener('click', function () {
      header.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-nav-open');
    });
  }

  if (searchToggle && searchDropdown) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchShell.classList.contains('is-open');
      searchShell.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      headerLockedOpen = !isOpen;
      if (headerLockedOpen) {
        header.classList.remove('is-hidden-on-scroll');
      }
      if (!isOpen && searchInput) {
        if (searchDefault) searchDefault.classList.remove('hidden');
        if (searchResults) searchResults.classList.add('hidden');
        window.setTimeout(function () {
          searchInput.focus();
        }, 40);
      }
    });

    if (searchInput) {
      searchInput.addEventListener('input', debounce(function () {
        var searchTerm = searchInput.value.trim();

        if (!searchTerm.length) {
          if (searchDefault) searchDefault.classList.remove('hidden');
          if (searchResults) {
            searchResults.innerHTML = '';
            searchResults.classList.add('hidden');
          }
          return;
        }

        fetchPredictiveResults(searchTerm);
      }, 220));
    }

    document.addEventListener('click', function (event) {
      if (!searchShell) return;
      if (!searchShell.contains(event.target)) {
        searchShell.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        headerLockedOpen = false;
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeQuickAdd();
        closeCartDrawer();
        searchShell.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        headerLockedOpen = false;
        if (header && toggle) {
          header.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('mobile-nav-open');
        }
      }
    });
  }

  if (header) {
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateHeaderVisibility();
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('wheel', function (event) {
      if (headerLockedOpen || header.classList.contains('is-open')) {
        header.classList.remove('is-hidden-on-scroll');
        return;
      }

      if (event.deltaY < -1) {
        header.classList.remove('is-hidden-on-scroll');
      } else if (event.deltaY > 6 && window.scrollY > 120) {
        header.classList.add('is-hidden-on-scroll');
      }
    }, { passive: true });
  }

  function updateHeaderVisibility() {
    if (!header) return;
      var currentScrollTop = window.scrollY || 0;
      var delta = currentScrollTop - lastScrollTop;

      header.classList.toggle('is-scrolled', currentScrollTop > 8);

      if (currentScrollTop <= 8) {
        header.classList.remove('is-hidden-on-scroll');
        lastScrollTop = currentScrollTop;
        return;
      }

      if (headerLockedOpen || header.classList.contains('is-open')) {
        header.classList.remove('is-hidden-on-scroll');
        lastScrollTop = currentScrollTop;
        return;
      }

      if (delta > 2 && currentScrollTop > 120) {
        header.classList.add('is-hidden-on-scroll');
      } else if (delta < -2) {
        header.classList.remove('is-hidden-on-scroll');
      }

      lastScrollTop = currentScrollTop;
  }

  if (heroSlider) {
    var heroSlides = Array.prototype.slice.call(heroSlider.querySelectorAll('[data-hero-slide]'));
    var heroDots = Array.prototype.slice.call(heroSlider.querySelectorAll('[data-hero-dot]'));
    var heroPrev = heroSlider.querySelector('[data-hero-prev]');
    var heroNext = heroSlider.querySelector('[data-hero-next]');
    var heroIndex = 0;
    var heroTimer;

    if (heroSlides.length > 1) {
      activateHeroSlide(0);
      startHeroAutoplay();

      if (heroPrev) {
        heroPrev.addEventListener('click', function () {
          activateHeroSlide(heroIndex - 1);
          startHeroAutoplay();
        });
      }

      if (heroNext) {
        heroNext.addEventListener('click', function () {
          activateHeroSlide(heroIndex + 1);
          startHeroAutoplay();
        });
      }

      heroDots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          activateHeroSlide(parseInt(dot.getAttribute('data-index') || '0', 10));
          startHeroAutoplay();
        });
      });
    }

    function activateHeroSlide(nextIndex) {
      heroIndex = (nextIndex + heroSlides.length) % heroSlides.length;
      heroSlides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === heroIndex);
        slide.querySelectorAll('video').forEach(function (video) {
          if (index === heroIndex) {
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      });
      heroDots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === heroIndex);
      });
    }

    function startHeroAutoplay() {
      if (heroTimer) window.clearInterval(heroTimer);
      heroTimer = window.setInterval(function () {
        activateHeroSlide(heroIndex + 1);
      }, 5000);
    }
  }

  initScrollReveal(document);
  initQualityShowcase(document);
  initTestimonialSliders(document);
  initProductForms(document);
  initCartPageForm(document);

  document.addEventListener('shopify:section:load', function (event) {
    initScrollReveal(event.target || document);
    initQualityShowcase(event.target || document);
    initTestimonialSliders(event.target || document);
    initProductForms(event.target || document);
    initCartPageForm(event.target || document);
  });

  if (cartToggle && cartDrawer) {
    cartToggle.addEventListener('click', function () {
      if (cartDrawer.hidden) {
        openCartDrawer();
      } else {
        closeCartDrawer();
      }
    });

    cartDrawer.querySelectorAll('[data-cart-close]').forEach(function (button) {
      button.addEventListener('click', closeCartDrawer);
    });

    cartDrawer.addEventListener('click', function (event) {
      var qtyButton = event.target.closest('[data-cart-qty]');
      var removeButton = event.target.closest('[data-cart-remove]');

      if (qtyButton) {
        event.preventDefault();
        var line = parseInt(qtyButton.getAttribute('data-line') || '0', 10);
        var nextQty = parseInt(qtyButton.getAttribute('data-cart-qty') || '0', 10);
        updateDrawerQuantityControl(line, nextQty);
        scheduleDrawerItemQuantityUpdate(line, nextQty);
        return;
      }

      if (removeButton) {
        event.preventDefault();
        updateDrawerItemQuantity(parseInt(removeButton.getAttribute('data-line') || '0', 10), 0);
      }
    });

    cartDrawer.addEventListener('change', function (event) {
      if (!event.target.matches('[data-cart-qty-input]')) return;
      var line = parseInt(event.target.getAttribute('data-line') || '0', 10);
      var quantity = Math.max(0, parseInt(event.target.value || '0', 10));
      event.target.value = String(quantity);
      scheduleDrawerItemQuantityUpdate(line, quantity);
    });
  }

  if (quickAddModal && quickAddContent) {
    document.querySelectorAll('[data-quick-add-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openQuickAdd(trigger);
      });
    });

    quickAddModal.querySelectorAll('[data-quick-add-close]').forEach(function (button) {
      button.addEventListener('click', closeQuickAdd);
    });
  }

  function fetchPredictiveResults(searchTerm) {
    if (predictiveRequest && typeof predictiveRequest.abort === 'function') {
      predictiveRequest.abort();
    }

    predictiveRequest = new AbortController();
    var url = '/search/suggest?q=' + encodeURIComponent(searchTerm) + '&resources[type]=product&resources[limit]=12&section_id=predictive-search';

    fetch(url, { signal: predictiveRequest.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Predictive search failed');
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var section = html.querySelector('#shopify-section-predictive-search');
        if (!section || !searchResults) return;
        searchResults.innerHTML = section.innerHTML;
        searchResults.classList.remove('hidden');
        if (searchDefault) searchDefault.classList.add('hidden');
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
      });
  }

  function debounce(fn, wait) {
    var timeout;
    return function () {
      var args = arguments;
      clearTimeout(timeout);
      timeout = window.setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function openQuickAdd(trigger) {
    var handle = trigger.getAttribute('data-product-handle');
    var productUrl = trigger.getAttribute('data-product-url') || '#';
    if (!handle) return;

    quickAddContent.innerHTML = '<div class="quick-add-sheet"><div class="quick-add-sheet__body"><div class="quick-add-sheet__eyebrow">Quick add</div><h2 id="QuickAddTitle" class="quick-add-sheet__title">Loading product...</h2><div class="quick-add-form__status">Fetching options</div></div></div>';
    quickAddModal.hidden = false;
    document.body.classList.add('modal-open');

    loadProduct(handle)
      .then(function (product) {
        renderQuickAdd(product, productUrl);
      })
      .catch(function () {
        quickAddContent.innerHTML = '<div class="quick-add-sheet"><div class="quick-add-sheet__body"><div class="quick-add-sheet__eyebrow">Quick add</div><h2 id="QuickAddTitle" class="quick-add-sheet__title">Could not load this product</h2><div class="quick-add-form__status">Please open the product page and try again.</div><div class="quick-add-form__actions"><a class="button" href="' + productUrl + '">Open product</a></div></div></div>';
      });
  }

  function closeQuickAdd() {
    if (!quickAddModal) return;
    quickAddModal.hidden = true;
    document.body.classList.remove('modal-open');
  }

  function loadProduct(handle) {
    if (quickAddCache[handle]) return Promise.resolve(quickAddCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load product');
        return response.json();
      })
      .then(function (product) {
        quickAddCache[handle] = product;
        return product;
      });
  }

  function renderQuickAdd(product, productUrl) {
    var firstAvailableVariant = product.variants.find(function (variant) {
      return variant.available;
    }) || product.variants[0];
    var featuredImage = product.featured_image || (product.images && product.images[0]) || '';

    quickAddContent.innerHTML =
      '<div class="quick-add-sheet">' +
        '<div class="quick-add-sheet__media">' +
          (featuredImage ? '<img src="' + escapeHtml(featuredImage) + '" alt="' + escapeHtml(product.title) + '">' : '') +
        '</div>' +
        '<div class="quick-add-sheet__body">' +
          '<div class="quick-add-sheet__eyebrow">Quick add</div>' +
          '<h2 id="QuickAddTitle" class="quick-add-sheet__title">' + escapeHtml(product.title) + '</h2>' +
          '<div class="quick-add-sheet__subtitle">' + escapeHtml(product.vendor || 'Premium product') + '</div>' +
          '<div class="quick-add-sheet__price" data-quick-add-price>' + renderPrice(firstAvailableVariant) + '</div>' +
          '<form class="quick-add-form" data-quick-add-form>' +
            renderVariantField(product, firstAvailableVariant) +
            '<div class="quick-add-form__row">' +
              '<label for="QuickAddQuantity">Quantity</label>' +
              '<div class="quick-add-form__quantity">' +
                '<button type="button" data-quick-qty=\"minus\">-</button>' +
                '<input id="QuickAddQuantity" type="number" min="1" value="1" data-quick-add-quantity>' +
                '<button type="button" data-quick-qty=\"plus\">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="quick-add-form__actions">' +
              '<button class="button-secondary" type="submit" data-quick-add-submit>' + (firstAvailableVariant.available ? 'Add to cart' : 'Sold out') + '</button>' +
              '<a class="button" href="' + buildCheckoutUrl(firstAvailableVariant.id, 1) + '" data-quick-add-buy>Buy now</a>' +
            '</div>' +
            '<div class="quick-add-form__status" data-quick-add-status>Select your variant and quantity.</div>' +
          '</form>' +
        '</div>' +
      '</div>';

    bindQuickAddForm(product, productUrl, firstAvailableVariant);
  }

  function bindQuickAddForm(product, productUrl, activeVariant) {
    var form = quickAddContent.querySelector('[data-quick-add-form]');
    if (!form) return;

    var variantSelect = form.querySelector('[data-quick-add-variant]');
    var quantityInput = form.querySelector('[data-quick-add-quantity]');
    var buyNowLink = form.querySelector('[data-quick-add-buy]');
    var priceNode = quickAddContent.querySelector('[data-quick-add-price]');
    var submitButton = form.querySelector('[data-quick-add-submit]');
    var statusNode = form.querySelector('[data-quick-add-status]');

    form.querySelectorAll('[data-quick-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var current = parseInt(quantityInput.value || '1', 10);
        var delta = button.getAttribute('data-quick-qty') === 'plus' ? 1 : -1;
        quantityInput.value = String(Math.max(1, current + delta));
        if (buyNowLink) buyNowLink.setAttribute('href', buildCheckoutUrl(getSelectedVariant().id, parseInt(quantityInput.value || '1', 10)));
      });
    });

    if (variantSelect) {
      initQuickAddVariantMenu(form, variantSelect);

      variantSelect.addEventListener('change', function () {
        var variant = getSelectedVariant();
        if (priceNode) priceNode.innerHTML = renderPrice(variant);
        if (buyNowLink) buyNowLink.setAttribute('href', buildCheckoutUrl(variant.id, parseInt(quantityInput.value || '1', 10)));
        if (submitButton) {
          submitButton.disabled = !variant.available;
          submitButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
      });
    }

    quantityInput.addEventListener('change', function () {
      var next = Math.max(1, parseInt(quantityInput.value || '1', 10));
      quantityInput.value = String(next);
      if (buyNowLink) buyNowLink.setAttribute('href', buildCheckoutUrl(getSelectedVariant().id, next));
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var variant = getSelectedVariant();
      var quantity = Math.max(1, parseInt(quantityInput.value || '1', 10));
      if (!variant.available) return;

      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';
      if (statusNode) statusNode.textContent = 'Adding to cart...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variant.id,
          quantity: quantity
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add failed');
          return response.json();
        })
        .then(function () {
          submitButton.textContent = 'Added';
          if (statusNode) statusNode.textContent = 'Added to cart.';
          closeQuickAdd();
          openCartDrawer();
        })
        .catch(function () {
          submitButton.disabled = false;
          submitButton.textContent = 'Add to cart';
          if (statusNode) statusNode.innerHTML = 'Something went wrong. <a href="' + productUrl + '">Open product</a>';
        });
    });

    function getSelectedVariant() {
      if (!variantSelect) return activeVariant;
      var selectedId = parseInt(variantSelect.value || activeVariant.id, 10);
      return product.variants.find(function (variant) {
        return variant.id === selectedId;
      }) || activeVariant;
    }
  }

  function renderVariantField(product, activeVariant) {
    if (!product.variants || product.variants.length <= 1 || (product.variants.length === 1 && product.variants[0].title === 'Default Title')) {
      return '<input type="hidden" value="' + activeVariant.id + '" data-quick-add-variant>';
    }

    return (
      '<div class="quick-add-form__row">' +
        '<label for="QuickAddVariant">Options</label>' +
        '<div class="quick-add-variant-picker" data-quick-add-variant-picker>' +
          '<select id="QuickAddVariant" class="quick-add-variant-picker__native" data-quick-add-variant aria-hidden="true" tabindex="-1">' +
            product.variants.map(function (variant) {
              return '<option value="' + variant.id + '"' + (variant.id === activeVariant.id ? ' selected' : '') + (variant.available ? '' : ' disabled') + '>' +
                escapeHtml(variant.title) + ' - ' + formatMoney(variant.price) + (variant.available ? '' : ' (Sold out)') +
              '</option>';
            }).join('') +
          '</select>' +
          '<button class="quick-add-variant-picker__button" type="button" aria-haspopup="listbox" aria-expanded="false" data-quick-add-variant-toggle>' +
            '<span data-quick-add-variant-label>' + escapeHtml(activeVariant.title) + ' - ' + formatMoney(activeVariant.price) + '</span>' +
            '<span class="quick-add-variant-picker__chevron" aria-hidden="true">v</span>' +
          '</button>' +
          '<div class="quick-add-variant-picker__list" role="listbox" tabindex="-1" data-quick-add-variant-list hidden>' +
          product.variants.map(function (variant) {
            var label = escapeHtml(variant.title) + ' - ' + formatMoney(variant.price) + (variant.available ? '' : ' (Sold out)');
            return '<button class="quick-add-variant-picker__option' + (variant.id === activeVariant.id ? ' is-active' : '') + '" type="button" role="option" data-quick-add-variant-option value="' + variant.id + '" aria-selected="' + (variant.id === activeVariant.id ? 'true' : 'false') + '"' + (variant.available ? '' : ' disabled') + '>' +
              '<span>' + label + '</span>' +
            '</button>';
          }).join('') +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function initQuickAddVariantMenu(form, variantSelect) {
    var picker = form.querySelector('[data-quick-add-variant-picker]');
    if (!picker) return;

    var toggle = picker.querySelector('[data-quick-add-variant-toggle]');
    var label = picker.querySelector('[data-quick-add-variant-label]');
    var list = picker.querySelector('[data-quick-add-variant-list]');
    var options = Array.prototype.slice.call(picker.querySelectorAll('[data-quick-add-variant-option]'));

    if (!toggle || !label || !list || !options.length) return;

    function closeMenu() {
      picker.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      list.hidden = true;
    }

    function openMenu() {
      picker.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      list.hidden = false;
    }

    function syncMenu() {
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (selectedOption) label.textContent = selectedOption.textContent;

      options.forEach(function (option) {
        var isActive = option.value === variantSelect.value;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    toggle.addEventListener('click', function () {
      if (picker.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        if (option.disabled) return;
        variantSelect.value = option.value;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncMenu();
        closeMenu();
      });
    });

    variantSelect.addEventListener('change', syncMenu);

    document.addEventListener('click', function (event) {
      if (!picker.contains(event.target)) closeMenu();
    });

    syncMenu();
  }

  function renderPrice(variant) {
    var html = '<span class="price">' + formatMoney(variant.price) + '</span>';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html += '<span class="compare">' + formatMoney(variant.compare_at_price) + '</span>';
    }
    return html;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function buildCheckoutUrl(variantId, quantity) {
    return '/cart/' + variantId + ':' + quantity;
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    document.body.classList.add('cart-drawer-open');
    if (cartToggle) cartToggle.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(function () {
      if (cartDrawer) cartDrawer.classList.add('is-open');
    });
    fetchCart()
      .then(function (cart) {
        renderCartDrawer(cart);
      })
      .catch(function () {
        renderCartDrawerError();
      });
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    if (cartToggle) cartToggle.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      if (cartDrawer) {
        cartDrawer.hidden = true;
      }
    }, 300);
  }

  function fetchCart() {
    if (cartRequest && typeof cartRequest.abort === 'function') {
      cartRequest.abort();
    }
    cartRequest = new AbortController();
    return fetch('/cart.js', { signal: cartRequest.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      });
  }

  function updateDrawerItemQuantity(line, quantity) {
    if (!line || quantity < 0) return;
    cartDrawerRequestInFlight = true;
    setCartDrawerUpdatingState(line, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function (cart) {
        renderCartDrawer(cart);
      })
      .catch(function () {
        setCartDrawerUpdatingState(line, false);
        renderCartDrawerError('Could not update the cart.');
      })
      .finally(function () {
        cartDrawerRequestInFlight = false;
        if (cartDrawerPendingLine) {
          var nextLine = cartDrawerPendingLine;
          var nextQuantity = cartDrawerPendingQuantity;
          cartDrawerPendingLine = null;
          cartDrawerPendingQuantity = null;
          scheduleDrawerItemQuantityUpdate(nextLine, nextQuantity, 0);
        }
      });
  }

  function scheduleDrawerItemQuantityUpdate(line, quantity, delay) {
    if (!line || quantity < 0) return;

    if (cartDrawerUpdateTimer) window.clearTimeout(cartDrawerUpdateTimer);
    cartDrawerPendingLine = line;
    cartDrawerPendingQuantity = quantity;
    setCartDrawerUpdatingState(line, true);

    cartDrawerUpdateTimer = window.setTimeout(function () {
      if (cartDrawerRequestInFlight) return;
      var nextLine = cartDrawerPendingLine;
      var nextQuantity = cartDrawerPendingQuantity;
      cartDrawerPendingLine = null;
      cartDrawerPendingQuantity = null;
      updateDrawerItemQuantity(nextLine, nextQuantity);
    }, typeof delay === 'number' ? delay : 650);
  }

  function updateDrawerQuantityControl(line, quantity) {
    if (!cartDrawerBody) return;

    var row = cartDrawerBody.querySelector('[data-cart-line="' + line + '"]');
    if (!row) return;

    var input = row.querySelector('[data-cart-qty-input]');
    var buttons = row.querySelectorAll('[data-cart-qty][data-line="' + line + '"]');
    var minus = buttons[0];
    var plus = buttons[buttons.length - 1];

    if (input) input.value = String(quantity);
    if (minus) minus.setAttribute('data-cart-qty', String(Math.max(0, quantity - 1)));
    if (plus) plus.setAttribute('data-cart-qty', String(quantity + 1));
  }

  function renderCartDrawerLoading(message) {
    if (!cartDrawerBody) return;
    cartDrawerBody.innerHTML = '<div class="cart-drawer__status">' + (message || 'Loading cart...') + '</div>';
    if (cartDrawerFooter) cartDrawerFooter.innerHTML = '';
  }

  function renderCartDrawerError(message) {
    if (!cartDrawerBody) return;
    cartDrawerBody.innerHTML = '<div class="cart-drawer__status">' + (message || 'Could not load the cart.') + '</div>';
    if (cartDrawerFooter) {
      cartDrawerFooter.innerHTML = '<div class="cart-drawer__actions"><a class="button-secondary" href="/cart">View cart</a><a class="button" href="/checkout">Checkout</a></div>';
    }
  }

  function renderCartDrawer(cart) {
    if (!cartDrawerBody || !cartDrawerFooter) return;

    if (cartCount) {
      cartCount.textContent = String(cart.item_count);
      cartCount.classList.toggle('hidden', cart.item_count === 0);
    }

    if (!cart.items.length) {
      cartDrawerBody.innerHTML = '<div class="cart-drawer__empty"><h3 class="card-title">Your cart is empty</h3><p class="section-copy">Add a few favorites and they will show up here.</p></div>';
      cartDrawerFooter.innerHTML = '<div class="cart-drawer__actions"><a class="button" href="/collections/all">Shop products</a></div>';
      return;
    }

    cartDrawerBody.innerHTML = groupCartItems(cart.items).map(function (group) {
      var totalQuantityLabel = 'Total qty ' + String(group.totalQuantity);
      var groupUrl = group.url || '#';

      return '' +
        '<div class="cart-drawer__group">' +
          '<div class="cart-drawer__item">' +
            '<a class="cart-drawer__item-image" href="' + groupUrl + '">' +
              (group.image ? '<img src="' + escapeHtml(group.image) + '&width=220" alt="' + escapeHtml(group.title) + '">' : '') +
            '</a>' +
            '<div class="cart-drawer__item-copy">' +
              '<a class="cart-drawer__item-title" href="' + groupUrl + '">' + escapeHtml(group.title) + '</a>' +
              '<div class="cart-drawer__item-summary">' + totalQuantityLabel + '</div>' +
              '<div class="cart-drawer__item-price">' + renderCartPrice(group.originalPrice, group.totalPrice) + '</div>' +
              renderDiscountList(group.discountApplications) +
            '</div>' +
          '</div>' +
          '<div class="cart-drawer__variants">' +
            group.items.map(function (item) {
              var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
                ? item.variant_title
                : 'Standard option';

              return '' +
                '<div class="cart-drawer__variant-row" data-cart-line="' + item.line + '">' +
                  '<div class="cart-drawer__variant-meta">' +
                    '<div class="cart-drawer__item-variant">' + escapeHtml(variantTitle) + '</div>' +
                    '<div class="cart-drawer__variant-price">' + renderCartPrice(item.original_line_price, item.final_line_price) + '</div>' +
                  '</div>' +
                  renderDiscountList(item.discountApplications) +
                  '<div class="cart-drawer__item-controls">' +
                    '<div class="cart-drawer__qty">' +
                      '<button type="button" data-cart-qty="' + Math.max(0, item.quantity - 1) + '" data-line="' + item.line + '">-</button>' +
                      '<input type="number" min="0" value="' + item.quantity + '" data-cart-qty-input data-line="' + item.line + '">' +
                      '<button type="button" data-cart-qty="' + (item.quantity + 1) + '" data-line="' + item.line + '">+</button>' +
                    '</div>' +
                    '<button class="cart-drawer__remove" type="button" data-cart-remove data-line="' + item.line + '">Remove</button>' +
                  '</div>' +
                '</div>';
            }).join('') +
          '</div>' +
        '</div>';
    }).join('');

    var totalDiscount = getAutomaticDiscountTotal(cart);
    var originalTotal = cart.original_total_price || cart.items_subtotal_price || cart.total_price;
    var automaticCartDiscounts = getAutomaticCartDiscounts(cart);

    cartDrawerFooter.innerHTML =
      (totalDiscount > 0 ? '<div class="cart-drawer__subtotal-row cart-drawer__subtotal-row--muted"><span>Before discounts</span><strong>' + formatMoney(originalTotal) + '</strong></div>' : '') +
      (totalDiscount > 0 ? '<div class="cart-drawer__discount-total"><span>Discounts</span><strong>-' + formatMoney(totalDiscount) + '</strong></div>' : '') +
      renderDiscountList(automaticCartDiscounts, 'cart-drawer__discount-list--footer') +
      '<div class="cart-drawer__subtotal-row"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>' +
      '<div class="cart-drawer__actions"><a class="button-secondary" href="/cart">View cart</a><a class="button" href="/checkout">Checkout</a></div>';
  }

  function setCartDrawerUpdatingState(line, isUpdating) {
    if (!cartDrawerBody || !cartDrawerFooter) return;

    var item = cartDrawerBody.querySelector('[data-cart-line="' + line + '"]');
    if (item) {
      item.classList.toggle('is-updating', isUpdating);
      var price = item.querySelector('.cart-drawer__variant-price') || item.querySelector('.cart-drawer__item-price');
      if (price) price.classList.toggle('is-updating', isUpdating);
    }

    var subtotal = cartDrawerFooter.querySelector('.cart-drawer__subtotal-row');
    if (subtotal) subtotal.classList.toggle('is-updating', isUpdating);
  }

  function groupCartItems(items) {
    return items.reduce(function (groups, item, index) {
      var key = String(item.product_id || item.handle || item.product_title || index);
      var automaticLineDiscounts = getAutomaticDiscounts(item.line_level_discount_allocations);
      var group = groups.find(function (entry) {
        return entry.key === key;
      });

      if (!group) {
        group = {
          key: key,
          title: item.product_title,
          url: item.url,
          image: item.featured_image ? item.featured_image.url : '',
          totalQuantity: 0,
          totalPrice: 0,
          originalPrice: 0,
          discountApplications: [],
          items: []
        };
        groups.push(group);
      }

      group.totalQuantity += item.quantity;
      group.totalPrice += item.final_line_price;
      group.originalPrice += item.original_line_price || item.line_price || item.final_line_price;
      group.discountApplications = group.discountApplications.concat(automaticLineDiscounts);
      group.items.push({
        line: index + 1,
        key: item.key,
        quantity: item.quantity,
        original_line_price: item.original_line_price || item.line_price || item.final_line_price,
        final_line_price: item.final_line_price,
        variant_title: item.variant_title,
        discountApplications: automaticLineDiscounts
      });

      return groups;
    }, []);
  }

  function isAutomaticDiscount(discount) {
    if (!discount) return false;
    if (discount.type) return discount.type === 'automatic';
    if (discount.discount_application && discount.discount_application.type) {
      return discount.discount_application.type === 'automatic';
    }
    return false;
  }

  function getAutomaticDiscounts(discounts) {
    if (!discounts || !discounts.length) return [];
    return discounts.filter(isAutomaticDiscount);
  }

  function getDiscountAmount(discount) {
    return Number(discount && (discount.amount || discount.total_allocated_amount || 0)) || 0;
  }

  function getAutomaticCartDiscounts(cart) {
    if (!cart) return [];
    return getAutomaticDiscounts(cart.cart_level_discount_applications || cart.discount_applications || []);
  }

  function getAutomaticDiscountTotal(cart) {
    if (!cart) return 0;

    var lineDiscountTotal = (cart.items || []).reduce(function (total, item) {
      return total + getAutomaticDiscounts(item.line_level_discount_allocations).reduce(function (lineTotal, discount) {
        return lineTotal + getDiscountAmount(discount);
      }, 0);
    }, 0);

    var cartDiscountTotal = getAutomaticCartDiscounts(cart).reduce(function (total, discount) {
      return total + getDiscountAmount(discount);
    }, 0);

    return lineDiscountTotal + cartDiscountTotal;
  }

  function renderCartPrice(originalPrice, finalPrice) {
    var original = typeof originalPrice === 'number' ? originalPrice : finalPrice;
    if (original > finalPrice) {
      return '<span class="cart-price cart-price--discounted">' + formatMoney(finalPrice) + '</span><span class="cart-price cart-price--compare">' + formatMoney(original) + '</span>';
    }
    return '<span class="cart-price">' + formatMoney(finalPrice) + '</span>';
  }

  function renderDiscountList(discounts, extraClass) {
    var automaticDiscounts = getAutomaticDiscounts(discounts);
    if (!automaticDiscounts.length) return '';
    var className = 'cart-drawer__discount-list' + (extraClass ? ' ' + extraClass : '');
    return '<div class="' + className + '">' + automaticDiscounts.map(function (discount) {
      var title = discount.title || (discount.discount_application && discount.discount_application.title) || 'Discount';
      var amount = getDiscountAmount(discount);
      return '<div class="cart-drawer__discount"><span>' + escapeHtml(title) + '</span>' + (amount > 0 ? '<strong>-' + formatMoney(amount) + '</strong>' : '') + '</div>';
    }).join('') + '</div>';
  }

  function initProductForms(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var forms = Array.prototype.slice.call(scope.querySelectorAll('[data-product-page-form]')).filter(function (form) {
      return !form.dataset.productFormBound;
    });

    forms.forEach(function (form) {
      form.dataset.productFormBound = 'true';

      var submitButton = form.querySelector('.product-form__submit');
      var buyNowLink = form.querySelector('[data-product-buy-now]');
      var statusNode = form.querySelector('[data-product-form-status]');
      var variantInput = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');

      initProductVariantMenu(form, variantInput);
      syncProductFormActions();

      if (variantInput) {
        variantInput.addEventListener('change', syncProductFormActions);
      }

      if (quantityInput) {
        quantityInput.addEventListener('change', syncProductFormActions);
        quantityInput.addEventListener('input', syncProductFormActions);
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var variantId = parseInt(variantInput ? variantInput.value : '0', 10);
        var quantity = Math.max(1, parseInt(quantityInput ? quantityInput.value : '1', 10));

        if (!variantId || !submitButton || submitButton.disabled) return;

        submitButton.disabled = true;
        submitButton.textContent = 'Adding...';
        if (statusNode) statusNode.textContent = 'Adding to cart...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add failed');
            return response.json();
          })
          .then(function () {
            submitButton.textContent = 'Added';
            if (statusNode) statusNode.textContent = 'Added to cart.';
            openCartDrawer();
            window.setTimeout(function () {
              submitButton.disabled = false;
              submitButton.textContent = 'Add to cart';
            }, 600);
          })
          .catch(function () {
            submitButton.disabled = false;
            submitButton.textContent = 'Add to cart';
            if (statusNode) statusNode.textContent = 'Something went wrong. Please try again.';
          });
      });

      function syncProductFormActions() {
        var variantId = parseInt(variantInput ? variantInput.value : '0', 10);
        var quantity = Math.max(1, parseInt(quantityInput ? quantityInput.value : '1', 10));
        var variantOption = variantInput && variantInput.options
          ? variantInput.options[variantInput.selectedIndex]
          : null;
        var isAvailable = variantOption
          ? !variantOption.disabled
          : !submitButton || !submitButton.disabled;

        if (quantityInput) {
          quantityInput.value = String(quantity);
        }

        if (buyNowLink) {
          if (variantId) {
            buyNowLink.setAttribute('href', buildCheckoutUrl(variantId, quantity));
          }

          buyNowLink.classList.toggle('is-disabled', !isAvailable || !variantId);
          buyNowLink.setAttribute('aria-disabled', (!isAvailable || !variantId) ? 'true' : 'false');

          if (!isAvailable || !variantId) {
            buyNowLink.setAttribute('tabindex', '-1');
          } else {
            buyNowLink.removeAttribute('tabindex');
          }
        }

        if (submitButton) {
          submitButton.disabled = !isAvailable || !variantId;
          submitButton.textContent = isAvailable ? 'Add to cart' : 'Sold out';
        }
      }
    });
  }

  function initCartPageForm(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var forms = Array.prototype.slice.call(scope.querySelectorAll('[data-cart-page-form]')).filter(function (form) {
      return !form.dataset.cartPageFormBound;
    });

    forms.forEach(function (form) {
      var submitTimer;
      var requestInFlight = false;
      var refreshPending = false;
      var pendingLineKey = null;
      var pendingQuantity = null;
      var itemsRegion = form.querySelector('[data-cart-page-items]');
      var summaryRegion = form.querySelector('[data-cart-page-summary]');

      form.dataset.cartPageFormBound = 'true';

      form.addEventListener('click', function (event) {
        var removeButton = event.target.closest('[data-cart-page-remove]');
        if (removeButton) {
          event.preventDefault();
          pendingLineKey = removeButton.getAttribute('data-cart-line-key');
          pendingQuantity = 0;
          updateCartLine(pendingLineKey, 0);
          return;
        }

        var button = event.target.closest('[data-cart-page-qty-button]');
        if (!button) return;

        var input = button.parentElement && button.parentElement.querySelector('[data-cart-page-qty]');
        if (!input) return;

        var delta = parseInt(button.getAttribute('data-cart-qty-delta') || '0', 10);
        var nextQuantity = Math.max(0, parseInt(input.value || '0', 10) + delta);
        input.value = String(nextQuantity);
        input.dataset.previousValue = input.value;
        scheduleCartLineUpdate(input, nextQuantity);
      });

      form.addEventListener('focusin', function (event) {
        if (!event.target.matches('[data-cart-page-qty]')) return;
        event.target.dataset.previousValue = event.target.value;
      });

      form.addEventListener('change', function (event) {
        if (!event.target.matches('[data-cart-page-qty]')) return;

        var input = event.target;
        var nextQuantity = Math.max(0, parseInt(input.value || '0', 10));
        input.value = String(nextQuantity);

        if (input.value === input.dataset.previousValue) return;
        input.dataset.previousValue = input.value;

        scheduleCartLineUpdate(input, nextQuantity);
      });

      form.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' || !event.target.matches('[data-cart-page-qty]')) return;
        event.preventDefault();
        event.target.blur();
      });

      function scheduleCartLineUpdate(input, nextQuantity) {
        var status = form.querySelector('[data-cart-page-status]');

        if (submitTimer) window.clearTimeout(submitTimer);
        if (status) status.textContent = 'Updating cart...';

        pendingLineKey = input.getAttribute('data-cart-line-key');
        pendingQuantity = nextQuantity;

        submitTimer = window.setTimeout(function () {
          updateCartLine(pendingLineKey, pendingQuantity);
        }, 650);
      }

      function updateCartLine(lineKey, quantity) {
        var status = form.querySelector('[data-cart-page-status]');

        if (!lineKey || requestInFlight) {
          refreshPending = true;
          return;
        }

        requestInFlight = true;
        if (status) status.textContent = 'Updating cart...';

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: quantity
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart update failed');
            return response.json();
          })
          .then(function (cart) {
            renderCartPageFromCart(form, cart, itemsRegion, summaryRegion);
          })
          .catch(function () {
            if (status) status.textContent = 'Could not update cart.';
          })
          .finally(function () {
            requestInFlight = false;
            if (refreshPending) {
              refreshPending = false;
              updateCartLine(pendingLineKey, pendingQuantity);
            }
          });
      }

      function refreshCartPage(form, itemsRegion, summaryRegion) {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart fetch failed');
            return response.json();
          })
          .then(function (cart) {
            renderCartPageFromCart(form, cart, itemsRegion, summaryRegion);
          });
      }
    });
  }

  function renderCartPageFromCart(form, cart, itemsRegion, summaryRegion) {
    var statusNode = form ? form.querySelector('[data-cart-page-status]') : null;

    if (statusNode) statusNode.textContent = 'Cart updated.';
    if (cart && typeof cart.item_count === 'number') {
      updateCartCount(cart.item_count);
    }

    if (itemsRegion) {
      itemsRegion.innerHTML = renderCartPageGroups(cart.items || []);
    }

    if (summaryRegion) {
      summaryRegion.innerHTML = renderCartPageSummary(cart);
    }

  }

  function renderCartPageGroups(items) {
    if (!items.length) {
      return '<div class="empty-state" style="text-align:center;"><h2 class="card-title" style="font-size:2rem;">Your cart is empty</h2><p class="section-copy">Browse the collection and add your first premium charger.</p><a class="button" href="/collections/all">Shop products</a></div>';
    }

    var groups = groupCartItems(items);
    return groups.map(function (group) {
      return '' +
        '<div class="cart-item">' +
          '<div class="cart-item__media">' +
            (group.image ? '<img class="cart-item__image" src="' + escapeHtml(group.image) + '&width=260" alt="' + escapeHtml(group.title) + '">' : '') +
          '</div>' +
          '<div class="cart-item__content">' +
            '<div class="cart-item__summary">' +
              '<div class="cart-item__details">' +
                '<h2 class="card-title cart-item__title">' + escapeHtml(group.title) + '</h2>' +
                '<div class="section-copy cart-item__variant">' + group.items.length + ' option' + (group.items.length === 1 ? '' : 's') + ' - ' + group.totalQuantity + ' item' + (group.totalQuantity === 1 ? '' : 's') + '</div>' +
              '</div>' +
              '<div class="cart-line-price cart-item__price">' + renderCartPrice(group.originalPrice, group.totalPrice) + '</div>' +
            '</div>' +
            '<div class="cart-item__variants">' +
              group.items.map(function (item) {
                return '' +
                  '<div class="cart-item__variant-row">' +
                    '<div class="cart-item__variant-meta">' +
                      '<div>' +
                        '<div class="cart-item__variant-name">' + escapeHtml(item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : 'Standard option') + '</div>' +
                        '<div class="cart-line-price cart-item__variant-price">' + renderCartPrice(item.original_line_price, item.final_line_price) + '</div>' +
                        renderDiscountList(item.discountApplications, 'cart-discount-list--line') +
                      '</div>' +
                    '</div>' +
                    '<div class="cart-item__quantity">' +
                      '<div class="cart-item__qty-stepper">' +
                        '<button class="cart-item__qty-button" type="button" data-cart-page-qty-button data-cart-qty-delta="-1" aria-label="Decrease quantity for ' + escapeHtml(group.title) + ' - ' + escapeHtml(item.variant_title || 'Standard option') + '">-</button>' +
                        '<input class="cart-item__qty-input" type="number" min="0" value="' + item.quantity + '" data-cart-page-qty data-cart-line-key="' + escapeHtml(String(item.key)) + '" aria-label="Quantity for ' + escapeHtml(group.title) + ' - ' + escapeHtml(item.variant_title || 'Standard option') + '">' +
                        '<button class="cart-item__qty-button" type="button" data-cart-page-qty-button data-cart-qty-delta="1" aria-label="Increase quantity for ' + escapeHtml(group.title) + ' - ' + escapeHtml(item.variant_title || 'Standard option') + '">+</button>' +
                      '</div>' +
                      '<button class="cart-item__remove" type="button" data-cart-page-remove data-cart-line-key="' + escapeHtml(String(item.key)) + '" aria-label="Remove ' + escapeHtml(group.title) + ' - ' + escapeHtml(item.variant_title || 'Standard option') + '">Remove</button>' +
                    '</div>' +
                  '</div>';
              }).join('') +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function renderCartPageSummary(cart) {
    var totalDiscount = getAutomaticDiscountTotal(cart);
    var automaticCartDiscounts = getAutomaticCartDiscounts(cart);

    return '' +
      '<div>' +
        (totalDiscount > 0 ? '<div class="cart-discount-row cart-discount-row--summary"><span>Discounts</span><strong>-' + formatMoney(totalDiscount) + '</strong></div>' : '') +
        renderDiscountList(automaticCartDiscounts, 'cart-discount-list--summary') +
        '<div class="section-copy">Subtotal</div>' +
        '<div class="section-title" style="font-size:2rem;margin:.25rem 0 0;">' + formatMoney(cart.total_price) + '</div>' +
      '</div>' +
      '<div class="product-actions">' +
        '<div class="cart-auto-update-status" data-cart-page-status aria-live="polite">Cart updated.</div>' +
        '<noscript><button class="button-secondary" type="submit" name="update">Update cart</button></noscript>' +
        '<button class="button" type="submit" name="checkout">Checkout</button>' +
      '</div>';
  }

  function updateCartCount(count) {
    if (!cartCount) return;
    cartCount.textContent = String(count);
    cartCount.classList.toggle('hidden', count === 0);
  }

  function initProductVariantMenu(form, variantInput) {
    if (!variantInput || !variantInput.options) return;

    var picker = form.querySelector('[data-product-variant-picker]');
    if (!picker) return;

    var toggle = picker.querySelector('[data-product-variant-toggle]');
    var label = picker.querySelector('[data-product-variant-label]');
    var list = picker.querySelector('[data-product-variant-list]');
    var options = Array.prototype.slice.call(picker.querySelectorAll('[data-product-variant-option]'));

    if (!toggle || !label || !list || !options.length) return;

    function closeMenu() {
      picker.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      list.hidden = true;
    }

    function openMenu() {
      picker.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      list.hidden = false;
    }

    function syncMenu() {
      var selectedOption = variantInput.options[variantInput.selectedIndex];
      if (selectedOption) label.textContent = selectedOption.textContent.trim();

      options.forEach(function (option) {
        var isActive = option.value === variantInput.value;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    toggle.addEventListener('click', function () {
      if (picker.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        if (option.disabled) return;
        variantInput.value = option.value;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        syncMenu();
        closeMenu();
      });
    });

    variantInput.addEventListener('change', syncMenu);

    document.addEventListener('click', function (event) {
      if (!picker.contains(event.target)) closeMenu();
    });

    syncMenu();
  }

  function initScrollReveal(root) {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var selectors = [
      '.section-header',
      '.about-story__shell',
      '.about-range__shell',
      '.about-stats-grid',
      '.product-card',
      '.quality-card',
      '.quality-showcase__shell',
      '.testimonial-card',
      '.cta-banner__inner',
      '.product-layout',
      '.complementary-card',
      '.cart-shell',
      '.page-shell',
      '.empty-state'
    ];

    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var elements = Array.prototype.slice.call(scope.querySelectorAll(selectors.join(','))).filter(function (element) {
      return !element.dataset.revealBound;
    });
    if (!elements.length) return;

    elements.forEach(function (element) {
      element.dataset.revealBound = 'true';
      element.classList.add('reveal-on-scroll');

      if (
        element.classList.contains('product-card') ||
        element.classList.contains('quality-card') ||
        element.classList.contains('testimonial-card')
      ) {
        element.classList.add('reveal-on-scroll--soft');
        var siblings = Array.prototype.slice.call(element.parentElement ? element.parentElement.children : []);
        var index = Math.max(0, siblings.indexOf(element));
        element.style.setProperty('--reveal-delay', String(Math.min(index, 5) * 70) + 'ms');
      }
    });

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('is-visible');
      });
      return;
    }

    window.requestAnimationFrame(function () {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var delay = parseInt(entry.target.style.getPropertyValue('--reveal-delay') || '0', 10);
          window.setTimeout(function () {
            entry.target.classList.add('is-visible');
          }, Math.max(90, delay));

          observer.unobserve(entry.target);
        });
      }, {
        threshold: 0.12,
        rootMargin: '0px 0px -10% 0px'
      });

      elements.forEach(function (element) {
        if (isElementInViewport(element, 0.9)) {
          var eagerDelay = parseInt(element.style.getPropertyValue('--reveal-delay') || '0', 10);
          window.setTimeout(function () {
            element.classList.add('is-visible');
          }, 120 + eagerDelay);
          return;
        }

        observer.observe(element);
      });
    });
  }

  function initQualityShowcase(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll('[data-quality-showcase]')).filter(function (section) {
      return !section.dataset.qualityShowcaseBound;
    });

    sections.forEach(function (section) {
      section.dataset.qualityShowcaseBound = 'true';

      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-quality-tab]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-quality-panel]'));
      if (!tabs.length || !panels.length) return;

      panels.forEach(function (panel) {
        panel.hidden = false;
      });

      activateQualityPanel(section, tabs[0].getAttribute('data-index') || '0');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateQualityPanel(section, tab.getAttribute('data-index') || '0');
        });
      });
    });
  }

  function initTestimonialSliders(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var sliders = Array.prototype.slice.call(scope.querySelectorAll('[data-testimonial-slider]')).filter(function (slider) {
      return !slider.dataset.testimonialSliderBound;
    });

    sliders.forEach(function (slider) {
      slider.dataset.testimonialSliderBound = 'true';

      var track = slider.querySelector('[data-testimonial-track]');
      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-testimonial-slide]'));
      var prev = slider.querySelector('[data-testimonial-prev]');
      var next = slider.querySelector('[data-testimonial-next]');
      var dotsWrap = slider.querySelector('[data-testimonial-dots]');
      var currentPage = 0;
      var totalPages = 1;
      var cardsPerView = 1;
      var autoplayTimer;
      var touchStartX = 0;
      var touchStartY = 0;
      var touchDeltaX = 0;
      var isSwiping = false;

      if (!track || slides.length <= 1) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        if (dotsWrap) dotsWrap.hidden = true;
        return;
      }

      function getCardsPerView() {
        if (window.innerWidth <= 749) return 1;
        if (window.innerWidth <= 989) return 2;
        return 3;
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';

        for (var index = 0; index < totalPages; index += 1) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'testimonial-slider__dot';
          dot.setAttribute('aria-label', 'Go to testimonial group ' + (index + 1));
          dot.setAttribute('data-index', String(index));
          dot.addEventListener('click', function () {
            var nextIndex = parseInt(this.getAttribute('data-index') || '0', 10);
            activatePage(nextIndex);
            restartAutoplay();
          });
          dotsWrap.appendChild(dot);
        }
      }

      function activatePage(nextPage) {
        var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0') || 0;
        var slideWidth = slides[0] ? slides[0].getBoundingClientRect().width : 0;
        currentPage = Math.max(0, Math.min(nextPage, totalPages - 1));

        track.style.transform = 'translate3d(' + String((slideWidth + gap) * currentPage * -1) + 'px, 0, 0)';

        if (prev) prev.disabled = currentPage === 0;
        if (next) next.disabled = currentPage >= totalPages - 1;

        Array.prototype.slice.call(slider.querySelectorAll('.testimonial-slider__dot')).forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === currentPage);
        });
      }

      function recalc() {
        cardsPerView = getCardsPerView();
        totalPages = Math.max(1, slides.length - cardsPerView + 1);
        if (dotsWrap) dotsWrap.hidden = totalPages <= 1;
        if (prev) prev.hidden = totalPages <= 1;
        if (next) next.hidden = totalPages <= 1;
        buildDots();
        activatePage(Math.min(currentPage, totalPages - 1));
        restartAutoplay();
      }

      function startAutoplay() {
        if (window.innerWidth > 749 || totalPages <= 1) return;
        autoplayTimer = window.setInterval(function () {
          var nextPage = currentPage + 1 >= totalPages ? 0 : currentPage + 1;
          activatePage(nextPage);
        }, 4200);
      }

      function restartAutoplay() {
        if (autoplayTimer) window.clearInterval(autoplayTimer);
        startAutoplay();
      }

      if (prev) {
        prev.addEventListener('click', function () {
          activatePage(currentPage - 1);
          restartAutoplay();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          activatePage(currentPage + 1);
          restartAutoplay();
        });
      }

      slider.addEventListener('mouseenter', function () {
        if (autoplayTimer) window.clearInterval(autoplayTimer);
      });

      slider.addEventListener('mouseleave', function () {
        restartAutoplay();
      });

      slider.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchDeltaX = 0;
        isSwiping = true;
        if (autoplayTimer) window.clearInterval(autoplayTimer);
      }, { passive: true });

      slider.addEventListener('touchmove', function (event) {
        if (!isSwiping || !event.touches || event.touches.length !== 1) return;
        touchDeltaX = event.touches[0].clientX - touchStartX;
        var deltaY = event.touches[0].clientY - touchStartY;

        if (Math.abs(touchDeltaX) > Math.abs(deltaY) && Math.abs(touchDeltaX) > 12) {
          event.preventDefault();
        }
      }, { passive: false });

      slider.addEventListener('touchend', function () {
        if (!isSwiping) return;

        if (Math.abs(touchDeltaX) > 48) {
          if (touchDeltaX < 0) {
            activatePage(currentPage + 1 >= totalPages ? 0 : currentPage + 1);
          } else {
            activatePage(currentPage - 1 < 0 ? totalPages - 1 : currentPage - 1);
          }
        }

        isSwiping = false;
        touchDeltaX = 0;
        restartAutoplay();
      });

      slider.addEventListener('touchcancel', function () {
        isSwiping = false;
        touchDeltaX = 0;
        restartAutoplay();
      });

      window.addEventListener('resize', debounce(recalc, 120));
      recalc();
    });
  }

  function activateQualityPanel(section, activeIndex) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-quality-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-quality-panel]'));

    tabs.forEach(function (tab) {
      var isActive = (tab.getAttribute('data-index') || '0') === String(activeIndex);
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var isActive = (panel.getAttribute('data-index') || '0') === String(activeIndex);
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function isElementInViewport(element, ratio) {
    if (!element || typeof element.getBoundingClientRect !== 'function') return false;
    var rect = element.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;

    return (
      rect.top < viewportHeight * ratio &&
      rect.bottom > 0 &&
      rect.left < viewportWidth &&
      rect.right > 0
    );
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  document.querySelectorAll('[data-qty-button]').forEach(function (button) {
    button.addEventListener('click', function () {
      var target = document.getElementById(button.getAttribute('data-target'));
      if (!target) return;
      var value = parseInt(target.value || '1', 10);
      var step = button.getAttribute('data-qty-button') === 'plus' ? 1 : -1;
      var next = Math.max(1, value + step);
      target.value = String(next);
      target.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.addEventListener('click', function (event) {
    var backLink = event.target.closest('[data-history-back]');
    if (!backLink) return;

    if (window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  });
});
